var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.show)?_c('Base'):_vm._e(),(_vm.modal.show)?_c('Modal',{staticClass:"fadeIn animated"}):_vm._e(),_c('OutsideScript',{attrs:{"src":"//zthj.ztgame.com/js/download_link.js"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }